/*
* Salla Button Component: has many sizes, styles and loading state.
* You can use these classes to target the elements in the component.
*/

.s-button{
  &-wrap{
    
  }
  &-element{
    
  }
  &-link{
    
  }
  &-icon{
    
  }
  &-btn{
    
  }
  &-solid{
    
  }
  &-outline{
    
  }
  &-fill-none{
    
  }
  &-large{
    
  }
  &-small{
    
  }
  &-wide{
    
  }
  &-primary{
    
  }
  &-success{
    
  }
  &-warning{
    
  }
  &-danger{
    
  }
  &-light{
    
  }
  &-gray{
    
  }
  &-dark{
    
  }
  &-primary-link{
    
  }
  &-success-link{
    
  }
  &-warning-link{
    
  }
  &-danger-link{
    
  }
  &-light-link{
    
  }
  &-gray-link{
    
  }
  &-dark-link{
    
  }
  &-primary-outline{
    
  }
  &-success-outline{
    
  }
  &-warning-outline{
    
  }
  &-danger-outline{
    
  }
  &-light-outline{
    
  }
  &-gray-outline{
    
  }
  &-dark-outline{
    
  }
  &-disabled{
    
  }
  &-loader{

  }
  &-loader-start{
    
  }
  &-loader-end{
    
  }
  &-loader-center{
    
  }
  &-loader-after{
    
  }
  &-text{

  }
  &-hide{

  }
}
